<template>
  <nav
    class="flex justify-end md:justify-center items-center px-4 py-2 relative"
    ref="menuContainer"
  >
    <button
      class="md:hidden w-10 h-10 flex items-center justify-center rounded-full background-toggle outline-none border-none text-white"
      @click="toggleMenu"
    >
      <MenuIcon v-if="!isMenuOpen" class="w-6 h-6" />
      <XIcon v-else class="icon" />
    </button>

    <ul
      class="absolute left-0 right-0 md:static md:flex md:gap-4 items-start md:items-center justify-center bg-white md:bg-transparent shadow-md md:shadow-none mt-2 md:mt-0 z-9999"
      :class="{
        'flex flex-col items-start justify-start  px-3 py-1 ': isMenuOpen,
        hidden: !isMenuOpen,
        block: isMenuOpen,
      }"
      :style="{ top: '100%' }"
    >
      <li
        v-for="item in filteredMenuItems"
        :key="item.id"
        :class="{ 'w-full': isMenuOpen }"
      >
        <div
          :role="item.clickable ? 'button' : 'presentation'"
          :class="[
            'label px-3 xl:px-6 py-2 cursor-pointer flex items-center gap-2 ',
            {
              'justify-start': isMenuOpen,
              'rounded-none': isMenuOpen,
              'main-primary-20':
                !disabledButton(item.unique || item.text) &&
                currentItem === (item.unique || item.text),
              'font-medium text-sm leading-5 rounded-full': !isMenuOpen,
              'hover-effect':
                !disabledButton(item.unique || item.text) &&
                currentItem !== (item.unique || item.text),
              'main-primary-10': !disabledButton(item.unique || item.text),
              'cursor-not-allowed': disabledButton(item.unique || item.text),
            },
          ]"
          @click="handleClickMenuItem(item)"
        >
          <component
            :is="getFeatherIcon(item.icon)"
            v-if="item.icon"
            class="icon"
          />
          <div class="lg:block md:hidden block">
            {{ item.text }}
          </div>
          <div class="lg:hidden md:block hidden">
            {{ getFirstLetters(item.text) }}
          </div>
        </div>
      </li>
    </ul>
  </nav>
</template>
<script>
import * as FeatherIcons from 'vue-feather-icons';
import { menuDynamic } from '../utils/menu-dynamic';

export default {
  name: 'DynamicMenu',
  components: {
    ...FeatherIcons,
  },
  data() {
    return {
      currentItem: 'Painel Geral',
      menuItems: menuDynamic,
      isMenuOpen: false,
    };
  },
  props: {
    currentItemId: String,
    isLoading: Boolean,
  },
  watch: {
    currentItemId(newVal) {
      const matchedItem = this.menuItems.find(
        ({ unique, text }) => unique === newVal || text === newVal,
      );
      if (matchedItem) {
        const { unique, text } = matchedItem;
        const selectedItemIdentifier = unique || text;
        this.currentItem = selectedItemIdentifier;
      }
    },
  },
  computed: {
    filteredMenuItems() {
      if (this.isMenuOpen) {
        return this.menuItems.filter(
          (item) => item.text !== 'Modo Apresentação',
        );
      }
      return this.menuItems;
    },
  },
  methods: {
    selectItem(item) {
      this.currentItem = item;
      const { componentName } = item;
      this.$emit('change-view', componentName);
    },
    toggleFullScreen() {
      this.$emit('toggle-full-screen');
    },
    handleClickMenuItem({ clickable, text, unique, componentName }) {
      const itemKey = unique || text;
      if (!clickable || this.disabledButton(itemKey)) return;
      if (itemKey === 'Modo Apresentação') {
        this.toggleFullScreen();
        return;
      }
      if (itemKey === 'Configuração') {
        this.$emit('choose-division-modal', true);
        return;
      }
      this.handleSelectItem(itemKey, componentName);

      this.isMenuOpen = false;
    },
    handleSelectItem(text, componentName) {
      this.selectItem(text);
      if (componentName) {
        this.$emit('change-view', componentName);
      }
    },
    getFeatherIcon(iconName) {
      return FeatherIcons[iconName + 'Icon'] || 'span';
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    handleClickOutside(event) {
      if (!this.$refs.menuContainer.contains(event.target)) {
        this.isMenuOpen = false;
      }
    },
    getFirstLetters(phrase) {
      const words = phrase.split(' ');
      const firtsLetters = words.map((word) => word[0]);
      const abbreviation = firtsLetters.join('').toUpperCase();
      return abbreviation;
    },
    disabledButton(menu) {
      return this.isLoading && menu !== 'Configuração';
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@500&display=swap');

.label {
  font-family: Inter, sans-serif;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.25rem;
  letter-spacing: 0.25px;
}
.main-primary-10 {
  color: #0f4173;
}
.main-primary-20 {
  background-color: #cfdae6;
}
.icon {
  width: 1rem;
  height: 1rem;
}
.hover-effect:hover {
  background-color: #d9d9d9;
  color: #0f4173;
}

.background-toggle {
  background-color: #0f4173;
}
.z-9999 {
  z-index: 1005;
}
</style>
